export default __webpack_public_path__ + "static/media/sc191.c31a4b14.jpg";